// frontend/app/locales/de.ts
export const de = {
  sidebar: {
    main: "Hauptmenü",
    planning: "Planung",
    closings: "Abschlüsse",
    system: "System",
    dashboard: "Dashboard",
    transactions: "Transaktionen",
    investments: "Investitionen",
    calendar: "Kalender",
    recurring: "Wiederkehrend",
    envelopes: "Umschläge",
    debts: "Schulden & Kredite",
    goals: "Ziele",
    documents: "Telegram-Posteingang",
    balance: "Salden",
    data: "Stammdaten",
    settings: "Einstellungen",
    logout: "Abmelden",
    login: "Anmelden",
    language: "Sprache",
    more: "Mehr",
    home: "Startseite",
    expenses: "Ausgaben",
    envelopes_short: "Umschläge",
    wishlist: "Wunschliste",
  },
  settings: {
    title: "Einstellungen",
    subtitle: "Verwalten Sie Ihre Einstellungen, Ihr Profil und Ihre Sicherheitsdaten.",
    profile: "Persönliches Profil",
    preferences: "Systemeinstellungen",
    security: "Sicherheit",
    database_status: "Datenbankstatus",
    export_import: "Exportieren & Importieren",
    email_briefings: "Tägliche Briefings & Berichte",
    save: "Einstellungen speichern",
    change_password: "Kennwort ändern",
    current_password: "Aktuelles Kennwort",
    new_password: "Neues Kennwort",
    confirm_password: "Kennwort bestätigen",
    bio_authentication: "Biometrische Authentifizierung (Passkeys)",
    register_passkey: "Passkey registrieren",
    db_status_msg: "Die PostgreSQL-Datenbank ist aktiv und wurde erfolgreich synchronisiert.",
    export_btn: "JSON-Daten exportieren",
    import_btn: "JSON-Daten importieren",
    receive_briefings: "Morgendliches Briefing erhalten",
    receive_weekly: "Wöchentlichen Bericht erhalten",
    receive_monthly: "Monatlichen Bericht erhalten",
    base_currency: "Basiswährung",
    timezone: "Zeitzone",
    personal_info: {
      username: "Benutzername",
      email: "E-Mail",
      first_name: "Vorname",
      last_name: "Nachname",
      date_of_birth: "Geburtsdatum",
      phone_number: "Telefonnummer",
      address: "Adresse",
      city: "Stadt",
      state: "Staat / Bundesland",
      postal_code: "Postleitzahl",
      country: "Land",
      gender: "Geschlecht",
      select_gender: "Auswählen...",
      male: "Männlich",
      female: "Weiblich",
      other_gender: "Sonstiges",
      address_details: "Details (Gebäude, Wohnung)",
      address_details_placeholder: "Z.B. App. 4B",
      address_placeholder: "Z.B. Hauptstraße 123",
      city_placeholder: "Berlin",
      state_placeholder: "BE",
      postal_code_placeholder: "10115",
      job_section: "Beschäftigung & Steuern",
      tax_id: "Steuernummer / Steuer-ID",
      tax_id_placeholder: "Z.B. Steuer-Identifikationsnummer...",
      employment_status: "Beschäftigungsverhältnis",
      employment_status_placeholder: "Angestellt, Selbstständig...",
      job_title: "Berufsbezeichnung",
      job_title_placeholder: "Softwareentwickler..."
    },
    telegram: {
      title: "Telegram-Bot-Integration",
      desc: "Um den Bot zu nutzen, senden Sie ihm den Befehl {cmd}, um Ihre ID herauszufinden, und geben Sie diese unten ein.",
      placeholder: "Z.B. 123456789"
    },
    password_section: {
      title: "Zugangspasswort",
      desc: "Aktualisieren Sie Ihr Passwort regelmäßig, um Ihr Konto sicher zu halten.",
      btn: "Passwort ändern",
      modal_title: "Passwort ändern",
      cancel: "Abbrechen",
      confirm: "Bestätigen",
      saving: "Wird gespeichert..."
    },
    biometric: {
      title: "Biometrische Anmeldung",
      desc: "Melden Sie sich schnell mit Face ID, Touch ID oder Windows Hello an."
    },
    two_fa: {
      title: "Zwei-Faktor-Authentifizierung (2FA)",
      status_active: "AKTIV",
      desc: "Schützen Sie Ihr Konto mit einem Einmalcode, der von einer Authentifizierungs-App generiert wird.",
      disable_btn: "2FA deaktivieren",
      enable_btn: "2FA konfigurieren",
      modal_title: "2FA konfigurieren",
      modal_desc: "Scannen Sie diesen Code mit Ihrer Authentifizierungs-App (Google Authenticator, Authy, Raivo usw.)",
      manual_entry: "Oder geben Sie den geheimen Schlüssel manuell ein:",
      verify_label: "Code zur Verifizierung eingeben",
      verify_btn: "Jetzt aktivieren",
      verifying: "Wird verifiziert...",
      prompt_disable: "Geben Sie den 2FA-Code ein, um die Deaktivierung zu bestätigen:"
    },
    briefings: {
      morning_label: "Morgenbriefing",
      morning_desc: "Zusammenfassung der gestrigen Ausgaben und anstehende Fristen.",
      weekly_label: "Wöchentlicher Rückblick",
      weekly_desc: "Wöchentliche Analyse der Budgeteinhaltung.",
      monthly_label: "Monatlicher Bericht",
      monthly_desc: "Detaillierte monatliche Nettovermögensaufstellung."
    },
    toasts: {
      qr_err: "Fehler beim Generieren des QR-Codes",
      conn_err: "Verbindungsfehler",
      two_fa_enabled: "Zwei-Faktor-Authentifizierung aktiviert!",
      invalid_code: "Ungültiger Code",
      two_fa_disabled: "2FA deaktiviert.",
      disable_failed: "Ungültiger Code. Deaktivierung fehlgeschlagen.",
      profile_saved: "Profil aktualisiert!",
      save_err: "Fehler beim Speichern des Profils",
      pref_saved: "Einstellung gespeichert!",
      pref_save_err: "Einstellung konnte nicht gespeichert werden.",
      export_success: "Daten erfolgreich exportiert!",
      export_failed: "Fehler beim Exportieren der Daten.",
      passkey_todo: "Passkey-Funktion muss hier noch wiederhergestellt werden",
      password_mismatch: "Die neuen Passwörter stimmen nicht überein!",
      password_changed: "Passwort erfolgreich geändert!",
      password_change_err: "Fehler beim Ändern des Passworts",
      loading: "Einstellungen werden geladen..."
    }
  },
  dashboard: {
    title: "Finanz-Dashboard",
    subtitle: "Nettovermögen Dashboard",
    overview_tab: "Übersicht",
    wealth_tab: "Vermögen & FIRE",
    behavior_tab: "Verhalten",
    history_tab: "Historie & Daten",
    forecast_tab: "Prognosen",
    merchants_tab: "Zahlungsempfänger",
    budget_tab: "Budgets",
    seasonality_tab: "Saisonalität",
    gamification_tab: "Finanz-RPG",
    investments_tab: "Investitionen",
    view_as: "Anzeigen als:",
    burn_rate: "Tägliche Ausgabenrate",
    avg_ticket: "Durchschnittlicher Betrag",
    micro_tx: "Kaffeesyndrom (<15€)",
    no_spend_days: "Ausgabenfreie Tage",
    runway: "Überlebensdauer (Survival Runway)",
    years_to_fire: "Jahre bis F.I.R.E.",
    fire_target: "Ziel für Unabhängigkeit",
    net_worth: "Nettovermögen",
    liquid: "Liquide Mittel",
    invested: "Investiert",
    locked_goals: "In Sparzielen",
    velocity: "Vermögensaufbau-Geschwindigkeit",
    savings_rate: "Sparquote",
    distribution: "Kontenverteilung",
    in_bank: "Im Bankguthaben",
    unconfirmed_alert: "Sie haben {count} Transaktionen, die auf Bestätigung warten!",
    unconfirmed_sub: "Dies könnten Abonnements oder Telegram-Einträge sein.",
    go_to_tx: "Gehe zu Transaktionen",
    net_worth_in_bank: "In der Bank (Real):",
    net_worth_in_goals: "In Umschlägen:",
    net_worth_credits: "Ausstehende Kredite (Forderungen):",
    net_worth_debts: "Ausstehende Verbindlichkeiten (Schulden):",
    current_month_balance_title: "Saldo des laufenden Monats",
    pacing_title: "Ausgabenverlauf im Monatsbudget",
    pacing_time: "Zeit ({days} T)",
    pacing_spent: "Ausgegebenes Budget",
    eom_forecast_title: "Prognose zum Monatsende",
    eom_forecast_sub: "Schätzung basierend auf täglicher Ausgabenrate ({rate}/Tag)",
    financial_pressure_title: "Zahlungsplan & Finanzieller Druck",
    pressure_upcoming_7d: "Anstehend (7 Tage)",
    pressure_remaining_month: "Verbleibender Monat",
    pressure_next_month: "Nächster Monat",
    pressure_fixed_costs: "Fixkosten/Monat",
    outflows_plural: "{count} Ausgaben",
    planned_plural: "{count} geplant",
    pressure_base_msg: "Basisbelastung",
    wealth_breakdown: "Vermögensaufteilung",
    in_bank_label: "Auf der Bank: {amount}",
    credits_short: "{amount} Kredite / Forderungen",
    debts_short: "{amount} Schulden",
    wealth_velocity_label: "Vermögenszuwachs: {amount} / Tag",
    savings_rate_label: "Sparquote (Monat)",
    savings_rate_sub: "Ziel: 20% | Investitionsquote: {rate}%",
    fire_projection_title: "F.I.R.E. Prognose",
    fire_years: "{years} Jahre",
    fire_years_over_50: "> 50 Jahre",
    fire_target_label: "Ziel für Unabhängigkeit: {amount}",
    runway_label: "Überlebensdauer (Survival Runway):",
    runway_value: "{years} Jahre",
    progression_12m: "Entwicklung des Nettovermögens (12 Monate)",
    account_distribution: "Kontenverteilung",
    of_which_locked: "(Davon {amount} zweckgebunden)",
    dow_title: "Ausgaben nach Wochentagen",
    dow_avg: "Durchschnitt",
    weekend_weekday: "Wochenende vs. Wochentage",
    weekday_label: "Mo-Fr",
    weekend_label: "Sa-So",
    month_rhythm: "Monatsrhythmus",
    first_half_label: "Tage 1-15",
    second_half_label: "Tage 16-31",
    income_expense_ratio_title: "Verhältnis Einnahmen zu Ausgaben (Gesamtzeitraum)",
    ratio_desc: "Für jeden ausgegebenen 1€ nehmen Sie {ratio}€ ein",
    tx_count_label: "{count} Transaktionen",
    lifetime_flow: "Historischer Geldfluss",
    lifetime_flow_desc: "Geld, das seit Tag eins durch Ihre Konten geflossen ist.",
    generated_label: "Generiert",
    burned_label: "Ausgegeben",
    monthly_income_history: "Monatliche Einnahmen (Gesamtzeitraum)",
    monthly_expense_history: "Monatliche Ausgaben (Gesamtzeitraum)",
    monthly_income_tooltip: "Gesamteinnahmen",
    monthly_expense_tooltip: "Gesamtausgaben",
    top_expense_categories: "Top-Ausgabenkategorien (Gesamtzeitraum)",
    top_income_categories: "Haupt-Einnahmequellen (Gesamtzeitraum)",
    hall_of_fame: "Rekorde",
    max_single_expense: "Größte Einzelausgabe",
    max_single_income: "Größte Einzeleinnahme",
    worst_day: "Tag mit den höchsten Ausgaben",
    max_no_spend_streak: "Längste Serie ohne Ausgaben",
    days_suffix: "{days} Tage",
    days_suffix_streak: "{days} Tage 🔥",
    table: {
      year: "Jahr",
      income: "Einnahmen",
      outflows: "Ausgaben",
      net_savings: "Ersparnis Netto",
      pct_sav: "% Sparquote"
    },
    time_horizon: "Zeithorizont",
    years_label: "{years} Jahre",
    annual_return: "Jährliche Anlagerendite",
    capital_invested_compound: "Investiertes Kapital (Zinseszins)",
    today_label: "Heute",
    gain_label: "Gewinn",
    liquidity_growth: "Liquidität (Lineares Wachstum)",
    avg_savings_label: "Durchschnittliche Ersparnis: {amount}/Monat",
    projected_total_label: "Projiziertes Gesamtvermögen",
    vs_today_label: "im Vergleich zu heute",
    trajectory_title: "Vermögensentwicklung Prognose",
    invisible_tax_title: "Unsichtbare Steuer (Inflation 2%)",
    inflation_desc: "Ihre aktuellen {amount} an Liquidität, wenn sie {years} Jahre lang ungenutzt bleiben, verlieren an Kaufkraft um einen Gegenwert von:",
    year_n: "Jahr {n}",
    merchants_controparte: "Zahlungsempfänger / Gegenpartei",
    merchants_tx: "Transaktionen",
    merchants_total: "Gesamt ({type})",
    merchants_outflow: "Ausgegeben",
    merchants_inflow: "Erhalten",
    merchants_none: "Keine Gegenparteien gefunden.",
    merchants_page: "Seite {page} von {total}",
    merchants_prev: "Zurück",
    merchants_next: "Weiter",
    merchants_by_amount: "Nach Betrag",
    merchants_by_freq: "Nach Häufigkeit",
    budget_delete_title: "Budget löschen",
    budget_delete_msg: "Möchten Sie das Budget für {category} löschen?",
    budget_edit_title: "Budget bearbeiten",
    budget_new_title: "Neues Budget festlegen",
    budget_cat_label: "Ausgabenkategorie",
    budget_select_placeholder: "Auswählen...",
    budget_limit_label: "Höchstgrenze (€)",
    budget_cancel: "Abbrechen",
    budget_save: "Speichern",
    budget_spent_on: "Budgetauslastung",
    budget_set_limit: "+ Limit festlegen",
    budget_empty: "Sie haben noch keine monatlichen Budgets festgelegt. Klicken Sie auf \"+ Limit festlegen\", um zu beginnen.",
    budget_remaining: "Verbleibend: {amount}",
    seasonality_title: "Historische durchschnittliche Ausgaben nach Monaten",
    rpg_title: "Finanz-RPG",
    rpg_subtitle: "Ihr Verhaltens-HUD. Überleben Sie den Monat, brechen Sie Rekorde, steigen Sie im Level auf.",
    rpg_boss_title: "Bereich reserviert für Bosskämpfe (Schulden) oder Quests",
    rpg_boss_sub: "Demnächst...",
    investments_value: "Gesamtwert",
    investments_capital: "Investiertes Kapital",
    investments_pnl: "Gesamterfolg (Unrealisiertes P&L)",
    investments_positions: "Ihre Positionen",
    investments_tbl: {
      asset: "Wertpapier / Asset",
      shares: "Anteile",
      pmc: "Einstandspreis (PMC)",
      current_price: "Aktueller Kurs",
      value: "Wert",
      pnl: "Erfolg (P&L)"
    },
    sankey: {
      title: "Monatlicher Geldfluss ({month})",
      footer: "Einnahmen ➔ Monatsbudget ➔ Ausgaben / Ersparnisse",
      budget_mensile: "Monatsbudget",
      risparmio: "Ersparnis",
      avanzo: "Überschuss",
      entrate: "Einnahmen",
      spese: "Ausgaben",
      fondi_buste: "Umschläge",
      erosione: "Erosion"
    },
    milestones: {
      title: "Die Säulen des Wohlstands",
      subtitle: "Ihr Weg durch finanzielle Meilensteine im Laufe der Zeit.",
      reached: "Erreichte Stufe",
      real_worth: "Tatsächliches Nettovermögen",
      next_target: "Nächstes Ziel: €{target}k"
    },
    streak: {
      title: "Serie ohne Ausgaben",
      days: "Tage",
      broken: "Sie haben heute Geld ausgegeben. Die Serie ist gerissen.",
      promising: "Vielversprechender Start. Weiter so!",
      rhythm: "Gute Arbeit! Sie kommen in den Rhythmus.",
      unstoppable: "UNAUFHALTSAM! 🔥"
    },
    heatmap: {
      title: "Verhaltenskarte",
      generating: "Karte wird generiert...",
      outflows: "Ausgaben",
      inflows: "Einnahmen",
      balance: "Saldo",
      mon: "Mo",
      wed: "Mi",
      fri: "Fr",
      jan: "Jan",
      feb: "Feb",
      mar: "Mär",
      apr: "Apr",
      may: "Mai",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Okt",
      nov: "Nov",
      dec: "Dez"
    }
  },
  transactions: {
    title: "Transaktionen",
    subtitle: "Verwalten, filtern und erfassen Sie Ihre Zahlungsbewegungen.",
    filters: "Filter",
    new_tx: "Neue Transaktion",
    search: "Suchen...",
    start_date: "Startdatum",
    end_date: "Enddatum",
    category: "Kategorie",
    account: "Konto",
    payment_method: "Zahlungsart",
    type: "Typ",
    status: "Status",
    all: "ALLE",
    income: "Einnahme",
    expense: "Ausgabe",
    transfer: "Umbuchung",
    unconfirmed: "Zu bestätigen",
    confirm_delete: "Transaktion löschen",
    delete_msg: "Sind Sie sicher, dass Sie diese Transaktion löschen möchten? Dieser Schritt kann nicht rückgängig gemacht werden.",
    date: "Datum",
    description: "Beschreibung",
    amount: "Betrag",
    notes: "Notizen",
    envelope: "Umschlag",
    is_envelope_spending: "Aus Umschlag bezahlen",
    currency: "Währung",
    splits: "Ausgaben aufteilen",
    contacts: "Kontakte",
    new_btn: "+ Neu",
    confirm_btn: "Bestätigen",
    edit_btn: "Bearbeiten",
    delete_btn: "Löschen",
    no_tx_found: "Keine Transaktionen für die ausgewählten Filter gefunden.",
    loading_data: "Daten werden geladen...",
    today: "Heute",
    yesterday: "Gestern",
    filter_bar: {
      from_date: "Startdatum",
      to_date: "Enddatum",
      search_placeholder: "Z.B. Amazon, Restaurant, Miete...",
      search_label: "Freitextsuche",
      category_placeholder: "Alle Kategorien",
      account_placeholder: "Alle Konten",
      quick_filters_label: "Schnellfilter:",
      all: "Alle",
      today: "Heute",
      last_7: "Letzte 7 Tage",
      this_month: "Diesen Monat",
      last_month: "Letzten Monat",
      only_unconfirmed: "Nur zu bestätigen",
      found: "Gefunden:",
      delta: "Differenz:"
    },
    modal: {
      edit_title: "✏️ Bearbeiten",
      new_title: "✨ Neu",
      type_expense: "Ausgabe",
      type_income: "Einnahme",
      type_transfer: "Umbuchung",
      date_label: "DATUM",
      currency_label: "WÄHRUNG",
      amount_label: "BETRAG ({currency})",
      description_label: "BESCHREIBUNG",
      real_bank_charge: "TATSÄCHLICHE BANKBELASTUNG ({currency})",
      bank_charge_sub: "Der Betrag, den die Bank tatsächlich auf Ihrem Auszug belastet hat.",
      exchange_rate_label: "WECHSELKURS (inkl. Gebühren)",
      exchange_rate_sub: "Vom System mathematisch berechnet.",
      category_label: "KATEGORIE",
      new_category_link: "+ Neu",
      merchant_label: "GEGENPARTEI",
      new_merchant_link: "+ Neu",
      payment_method_label: "ZAHLUNGSART",
      new_payment_method_link: "+ Neu",
      money_movement_title: "GELDBEWEGUNG",
      new_account_btn: "+ Neues Konto anlegen",
      from_account_label: "BEZAHLEN MIT",
      from_account_transfer_label: "VON KONTO",
      to_account_label: "EINZAHLEN AUF",
      to_account_transfer_label: "NACH KONTO",
      envelope_title: "✉️ UMSCHLÄGE (Optional)",
      envelope_label: "UMSCHLAG VERKNÜPFEN",
      envelope_placeholder: "Kein Umschlag...",
      use_envelope_money: "Mittel aus Umschlag verwenden",
      use_envelope_money_sub: "Diese Ausgabe wirkt sich nicht auf Ihr Monatsbudget aus, da Sie die Mittel bereits in der Vergangenheit reserviert haben.",
      debts_mode_label: "Mit dieser Transaktion verknüpfte Schulden/Forderungen generieren",
      debts_add_item: "+ Zeile hinzufügen",
      debts_title: "Verknüpfte Schulden / Forderungen",
      debts_empty: "Keine verknüpften Schulden.",
      debts_new_btn: "+ Hinzufügen",
      notes_label: "NOTIZEN",
      tags_label: "Tags (Eingabetaste drücken)",
      tags_placeholder: "Z.B. urlaub, geschenk...",
      cancel_btn: "Abbrechen",
      save_btn: "Speichern",
      saving_btn: "Wird gespeichert...",
      split_lent: "Verliehen",
      split_borrowed: "Schuld",
      split_to_whom: "An wen?",
      split_amount_placeholder: "Anteil (€)",
      split_credito: "FORDERUNG",
      split_debito: "SCHULD"
    },
    confirm_delete_title: "Transaktion löschen",
    confirm_delete_msg: "Sind Sie sicher, dass Sie diese Transaktion löschen möchten? Dieser Vorgang ist unumkehrbar, und die Kontosalden werden neu berechnet.",
    quick_add_modal: {
      category_title: "Neue Kategorie ({type})",
      merchant_title: "Neue Gegenpartei",
      payment_title: "Neue Zahlungsart",
      name_placeholder: "Name...",
      cancel: "Abbrechen",
      save: "Speichern"
    },
    new_account_modal: {
      title: "Neues Konto",
      name_placeholder: "Name...",
      is_investment: "Investment-Konto",
      create: "Erstellen",
      cancel: "Abbrechen"
    }
  },
  auth: {
    login: {
      title: "MS Ledger",
      subtitle: "Schützen Sie Ihr Vermögen.",
      email_username: "E-Mail oder Benutzername",
      email_placeholder: "Geben Sie Ihre E-Mail ein",
      password: "Passwort",
      forgot_password: "Kennwort vergessen?",
      totp_code: "Sicherheitscode (2FA)",
      totp_placeholder: "000000",
      totp_desc: "Öffnen Sie Ihre Authentifizierungs-App, um den Code zu generieren.",
      remember_me: "Anmeldedaten für 30 Tage speichern",
      submit_2fa: "Verifizieren und Anmelden",
      submit_password: "Mit Passwort anmelden",
      back: "Zurück",
      or: "Oder",
      face_id: "Mit Passkey anmelden"
    },
    register: {
      subtitle: "Erstellen Sie ein neues Konto, um zu beginnen.",
      username: "Benutzername",
      username_placeholder: "z.B. mario99",
      email: "E-Mail-Adresse",
      email_placeholder: "mario@email.com",
      password: "Passwort",
      confirm_password: "Passwort bestätigen",
      submit: "Registrieren",
      have_account: "Haben Sie bereits ein Konto?",
      login_link: "Anmelden"
    },
    forgot_password: {
      title: "Passwort zurücksetzen",
      desc: "Geben Sie Ihre E-Mail-Adresse ein, um den Link zum Zurücksetzen zu erhalten.",
      email_placeholder: "Ihre E-Mail",
      submit: "Link senden",
      success: "Überprüfen Sie Ihre E-Mails! Wir haben Ihnen die Anweisungen gesendet."
    },
    reset_password: {
      title: "Neues Passwort",
      new_placeholder: "Neues Passwort",
      confirm_placeholder: "Passwort bestätigen",
      submit: "Passwort aktualisieren"
    },
    errors: {
      email_required: "Geben Sie oben Ihre E-Mail oder Ihren Benutzernamen ein, bevor Sie Face ID verwenden.",
      user_not_found: "Benutzer nicht gefunden.",
      verification_failed: "Verifizierung fehlgeschlagen.",
      biometric_error: "Biometrischer Fehler.",
      invalid_credentials: "Ungültige E-Mail-Adresse oder Passwort",
      passwords_mismatch: "Die Passwörter stimmen nicht überein.",
      password_length: "Das Passwort muss mindestens 6 Zeichen lang sein.",
      register_error: "Fehler bei der Registrierung.",
      request_error: "Fehler bei der Anfrage.",
      connection_error: "Verbindung fehlgeschlagen.",
      reset_error: "Fehler beim Zurücksetzen des Passworts.",
      network_error: "Netzwerkfehler.",
      success_register: "Registrierung abgeschlossen! Weiterleitung zum Login...",
      success_reset: "Passwort zurückgesetzt! Sie können sich jetzt anmelden."
    }
  },
  balance: {
    title: "Abschlüsse und Salden",
    subtitle: "Gleichen Sie die App-Salden mit den tatsächlichen Salden Ihrer Bankbelege ab.",
    reconciliation_btn: "Abgleich starten",
    calculating: "Wird berechnet...",
    liquid_title: "Liquidität & Girokonten",
    investments_title: "Investitionen",
    empty_msg: "Wählen Sie ein Datum und klicken Sie auf \"Abgleich starten\", um zu beginnen.",
    toasts: {
      load_err: "Fehler beim Laden der Kontosalden.",
      diff_err: "Das Guthaben auf den Girokonten muss exakt mit dem erwarteten Saldo übereinstimmen (Differenz = 0).",
      success_close: "Konto erfolgreich abgeglichen!",
      close_err: "Fehler: {detail}"
    },
    table: {
      account: "Konto",
      expected_balance: "Erwarteter Saldo (App)",
      actual_balance: "Tatsächlicher Saldo (Bank)",
      delta: "Differenz (Delta)",
      action: "Aktion",
      close_btn: "Konto abschließen",
      closed_status: "Abgeglichen",
      never_closed: "Noch nie abgeschlossen",
      last_closure: "Letzter: {date} ({amount})",
      copy_expected: "Kopieren",
      copy_expected_mobile: "Erwarteten kopieren",
      expected_label_mobile: "Erwarteter Saldo",
      actual_label_mobile: "Tatsächlicher Banksaldo",
      close_btn_mobile: "Abschließen"
    }
  },
  calendar_page: {
    title: "Kalender",
    subtitle: "Tägliche Cashflow-Ansicht mit zukünftigen Abonnement-Prognosen.",
    today: "Heute",
    loading_events: "Ereignisse werden geladen...",
    toasts: {
      load_err: "Fehler beim Laden der Daten"
    },
    grid: {
      days: ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"],
      days_short: ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"]
    }
  },
  data_page: {
    title: "Stammdaten",
    subtitle: "Konfigurieren Sie Kategorien, Konten, Gegenparteien und Karten.",
    search_placeholder: "Eintrag suchen...",
    new_btn: "Neu",
    tabs: {
      categories: "Kategorien",
      accounts: "Bankkonten",
      merchants: "Gegenparteien",
      payment_methods: "Zahlungsarten",
      contacts: "Kontakte"
    },
    table: {
      name: "Bezeichnung",
      type: "Typ",
      account_type: "Kontotyp",
      actions: "Aktionen",
      no_categories: "Keine Kategorien gefunden.",
      no_accounts: "Keine Konten gefunden.",
      no_merchants: "Keine Gegenparteien gefunden.",
      no_payments: "Keine Zahlungsarten gefunden.",
      no_contacts: "Keine Kontakte gefunden.",
      subcat_tooltip: "Unterkategorie hinzufügen",
      investment_badge: "Investment",
      liquidity_badge: "Liquidität"
    },
    modal: {
      delete_title: "Eintrag löschen",
      delete_message: "Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?",
      new_title: "Neuen Eintrag erstellen",
      edit_title: "Eintrag bearbeiten",
      name_label: "Name",
      transaction_type: "Transaktionstyp",
      type_expense: "Ausgabe",
      type_income: "Einnahme",
      type_transfer: "Umbuchung",
      parent_label: "Unterkategorie von (Optional)",
      parent_none: "-- Keine (Hauptkategorie) --",
      is_investment: "Investment-Konto",
      is_investment_sub: "Schließt dieses Konto aus der Cash-Liquiditätsberechnung aus.",
      cancel: "Abbrechen",
      save: "Speichern",
      first_name: "Vorname",
      last_name: "Nachname",
      email: "E-Mail-Adresse",
      phone_number: "Telefonnummer",
      vat_number: "USt-IdNr.",
      tax_code: "Steuernummer",
      address: "Adresse",
      website: "Website",
      matching_keywords: "Schlüsselwörter für Zuweisung (kommagetrennt)",
      is_credit_card: "Kreditkarte",
      is_credit_card_sub: "Identifiziert dieses Konto als Kreditkarte.",
      is_shared: "Gemeinschaftskonto",
      is_shared_sub: "Gemeinsam genutztes Konto.",
      is_obsolete: "Als veraltet / inaktiv markieren",
      is_obsolete_sub: "Aus den Hauptlisten ausblenden.",
      show_obsolete: "Veraltete anzeigen",
      color: "Farbe",
      icon: "Symbol",
      currency: "Währung"
    },
    toasts: {
      deleted: "Eintrag gelöscht.",
      delete_err: "Löschen fehlgeschlagen: {detail}",
      created: "Eintrag erstellt!",
      updated: "Eintrag aktualisiert!",
      save_err: "Fehler beim Speichern: {detail}",
      loading: "Lade Stammdaten..."
    }
  },
  debts_page: {
    title: "Schulden & Kredite",
    subtitle: "Verwalten Sie Darlehen an Freunde und Ihre eigenen ausstehenden Schulden.",
    new_friend: "Neuer Freund",
    new_debt: "Neue Schuld",
    active_tab: "Offen",
    settled_tab: "Ausgeglichen",
    empty_msg: "Keine Einträge in diesem Bereich.",
    toasts: {
      load_err: "Fehler beim Laden der Daten",
      deleted: "Schuld gelöscht!",
      delete_err: "Löschen fehlgeschlagen",
      contact_created: "Kontakt erstellt",
      debt_created: "Schuld erfasst",
      debt_updated: "Schuld aktualisiert",
      save_err: "Fehler beim Speichern",
      status_updated: "Status aktualisiert!",
      status_err: "Fehler beim Aktualisieren des Status",
      repay_linked: "Transaktion verknüpft!",
      repay_err: "Fehler",
      link_removed: "Verknüpfung entfernt!"
    },
    modal: {
      delete_title: "Schuld löschen",
      delete_message: "Sind Sie sicher, dass Sie diese Schuld löschen möchten? Dies ändert nichts an Ihren echten Bankkonten, löscht jedoch den Eintrag.",
      friend_title: "Neuer Freund",
      friend_name: "Name des Freundes",
      friend_placeholder: "Z.B. Max Mustermann",
      cancel: "Abbrechen",
      save: "Speichern",
      debt_title: "Schuld",
      debt_amount: "Gesamtbetrag",
      debt_desc: "Beschreibung (Optional)",
      debt_desc_placeholder: "Z.B. Pizza-Essen, Darlehen...",
      repay_title: "Abgleich verwalten",
      repay_remaining: "Verbleibender Saldo: {amount}",
      repay_status: "Status: {status}",
      repay_settled: "Ausgeglichen",
      repay_active: "Aktiv",
      repay_history: "Verknüpfte Transaktionen Historie",
      repay_amount_applied: "Zugeordneter Betrag",
      repay_no_links: "Keine verknüpften Transaktionen.",
      repay_link_new: "Neue Transaktion verknüpfen",
      repay_select_tx: "Wählen Sie eine Transaktion aus...",
      repay_amount_to_apply: "Diesem Eintrag zuzuordnender Betrag",
      repay_settle_checkbox: "Als ausgeglichen markieren (Schließen)",
      repay_submit: "Abgleich speichern",
      toggle_repay_status: "Als {status} markieren",
      type_lent: "Verliehen (Guthaben)",
      type_borrowed: "Geliehen (Schuld)",
      reopen_debt: "Schuld wieder eröffnen",
      close_debt: "Schuld schließen",
      repay_total: "Rückzahlung",
      remaining_label: "Verbleibend",
      tx_removed: "Transaktionsverknüpfung entfernt",
      search_tx: "Transaktion suchen",
      settled_info: "Diese Schuld ist derzeit ausgeglichen. Verwenden Sie die Schaltfläche 'Schuld wieder eröffnen', um neue Transaktionen hinzuzufügen, oder klicken Sie auf das Papierkorb-Symbol im Verlauf, um eine fehlerhafte Verknüpfung zu entfernen."
    },
    aggregations: {
      credits_title: "Offene Forderungen",
      debts_title: "Offene Schulden",
      net_balance: "Nettosaldo",
      net_credits: "Sie haben ein Guthaben von {amount}",
      net_debts: "Sie schulden insgesamt {amount}",
      net_balanced: "Ihre Schulden und Guthaben gleichen sich aus",
      by_friend: "Status je Person",
      friend_credit: "Schuldet Ihnen {amount}",
      friend_debt: "Sie schulden ihm/ihr {amount}",
      friend_settled: "Ausgeglichen"
    },
    card: {
      lent: "Verliehen an",
      borrowed: "Geliehen von",
      remaining: "Verbleibend: {amount} von {total}",
      settle_now: "Verknüpfen / Ausgleichen",
      settled: "Ausgeglichen",
      no_desc: "Keine Beschreibung"
    }
  },
  documents_page: {
    inbox_title: "Telegram Posteingang",
    empty_inbox: "Posteingang leer. Senden Sie eine Datei an den Bot!",
    preview_title: "Dokumentenvorschau",
    fullscreen_btn: "Vollbild öffnen",
    decrypting: "Datei wird entschlüsselt...",
    link_section_title: "Mit Transaktion verknüpfen",
    search_placeholder: "Nach Beschreibung oder Betrag suchen...",
    link_btn: "Hier verknüpfen",
    delete_btn: "Datei löschen",
    delete_confirm: "Datei dauerhaft löschen?",
    empty_selection: "Wählen Sie ein Dokument aus, um zu beginnen",
    other_features_soon: "Weitere Funktionen (In Kürze)",
    create_asset: "Asset erstellen",
    send_to_accountant: "An Steuerberater senden",
    archive_title: "Verknüpftes Archiv",
    tab_inbox: "Posteingang",
    tab_archive: "Archiv",
    empty_archive: "Keine verknüpften Dokumente gefunden.",
    linked_to: "Verknüpft mit Transaktion:",
    unlink_btn: "Verknüpfung aufheben",
    select_transaction_title: "Transaktion auswählen",
    alias_label: "Alias / Eigener Name",
    alias_placeholder: "Rechnung, Quittung...",
    save_alias_btn: "Umbenennen",
    toasts: {
      preview_err: "Dokumentenvorschau konnte nicht geladen werden.",
      linked: "Dokument verknüpft!",
      unlinked: "Verknüpfung aufgehoben!",
      alias_updated: "Alias aktualisiert!"
    }
  },
  envelopes_page: {
    title: "Umschläge (Budgets)",
    subtitle: "Legen Sie Geld für zukünftige Ausgaben und wiederkehrende Ziele beiseite.",
    new_btn: "Neuer Umschlag",
    liquid_title: "Verfügbares Girokonto-Guthaben",
    liquid_desc: "Das Guthaben, das auf Ihrer Bank-App sichtbar ist",
    allocated_title: "In Umschlägen verplant",
    allocated_desc: "Mental bereits 'ausgegebenes' Geld",
    unallocated_title: "Noch frei (Unverplant)",
    unallocated_desc: "Ihr TATSÄCHLICH frei verfügbares Vermögen",
    my_goals: "Ihre Umschläge",
    empty_msg: "Keine Umschläge eingerichtet. Erstellen Sie einen, um mit der Budgetierung zu beginnen!",
    toasts: {
      load_err: "Fehler beim Laden der Daten",
      deleted: "Umschlag gelöscht!",
      delete_err: "Löschen fehlgeschlagen",
      saved: "Umschlag gespeichert!",
      save_err: "Fehler beim Speichern des Umschlags"
    },
    card: {
      target: "Ziel: {target}",
      target_reached: "Erreicht!",
      delete_confirm: "Sind Sie sicher, dass Sie diesen Umschlag löschen möchten?",
      no_desc: "Keine Beschreibung",
      remaining_to_target: "Verbleibend: {amount}"
    },
    modal: {
      new_title: "Neuer Umschlag",
      edit_title: "Umschlag bearbeiten",
      delete_title: "Umschlag löschen",
      name: "Name des Umschlags",
      name_placeholder: "Z.B. Autoversicherung, Steuern...",
      allocated: "Zugeordneter Betrag (€)",
      target: "Zielbetrag (Optional, €)",
      description: "Notizen / Beschreibung",
      description_placeholder: "Z.B. Fällig im November, monatliches Sparziel...",
      cancel: "Abbrechen",
      save: "Speichern"
    }
  },
  goals_page: {
    title: "Finanzielle Ziele",
    subtitle: "Planen Sie Ihre langfristigen Sparziele.",
    new_btn: "Neues Sparziel",
    allocated_title: "In Zielen verplant",
    empty_msg: "Keine Sparziele definiert. Klicken Sie auf 'Neues Sparziel', um mit dem Sparen zu beginnen!",
    toasts: {
      load_err: "Fehler beim Laden der Daten",
      deleted: "Ziel gelöscht!",
      delete_err: "Löschen fehlgeschlagen",
      saved: "Ziel gespeichert!",
      save_err: "Fehler beim Speichern des Ziels",
      select_account: "Wählen Sie ein Konto aus!",
      alloc_success: "Mittel erfolgreich zugeordnet!",
      alloc_err: "Fehler bei Zuordnung: {detail}"
    },
    card: {
      target: "Ziel: {amount} bis {date}",
      allocated: "Zugeordnet: {amount} ({pct}%)",
      delete_confirm: "Sind Sie sicher, dass Sie dieses Sparziel löschen möchten?",
      target_date: "Zieltermin: {date}",
      add_funds: "Mittel hinzufügen"
    },
    modal: {
      new_title: "Neues Sparziel",
      edit_title: "Sparziel bearbeiten",
      delete_title: "Sparziel löschen",
      name: "Name des Sparziels",
      name_placeholder: "Z.B. Hauskauf, Japanreise...",
      target: "Zielbetrag (€)",
      deadline: "Fälligkeitsdatum",
      notes: "Notizen / Beschreibung",
      notes_placeholder: "Details zum Sparziel...",
      cancel: "Abbrechen",
      save: "Speichern",
      allocate_title_prefix: "Mittel verschieben nach",
      allocate_from_account: "VON WELCHEM KONTO ABBUCHEN?",
      allocate_select_account: "Konto auswählen...",
      allocate_desc: "Das Geld verbleibt in Ihrem Nettovermögen, wird jedoch von der freien Liquidität abgezogen.",
      allocate_amount: "BETRAG (€)",
      allocate_date: "DATUM",
      allocate_submit: "Einzahlen",
      optional: "Optional"
    }
  },
  investments_page: {
    title: "Investments & Portfolio",
    subtitle: "Überwachen Sie Assets, berechnen Sie den Einstandspreis (PMC) und erfassen Sie Transaktionen.",
    import_btn: "CSV importieren",
    new_asset_btn: "Neues Asset",
    new_order_btn: "Order erfassen",
    chart_title: "Portfolio Wertentwicklung Historie",
    empty_chart: "Keine historischen Daten für dieses Diagramm vorhanden.",
    positions_title: "Portfolio-Positionen",
    value: "Wert",
    commission: "Provisionen",
    order_type: "Ordertyp",
    date: "Datum",
    shares: "Anteile",
    price: "Preis",
    orders_history: "Orderverlauf",
    loading_msg: "Terminal wird initialisiert...",
    updating_data: "Daten werden aktualisiert...",
    broker_selector_all: "Alle Broker",
    ledger_empty: "Das Register ist leer. Erfassen Sie Ihre erste Transaktion.",
    positions_empty: "Keine offenen Positionen im Portfolio.",
    assets_empty: "Keine Assets registriert.",
    tab_positions: "Aktive Positionen",
    tab_ledger: "Orderverlauf (Register)",
    tab_assets: "Asset-Verzeichnis",
    broker_liquidity: "Broker Liquidität",
    table: {
      asset: "Asset",
      shares: "Anteile",
      pmc: "Einstandspreis (PMC)",
      current_price: "Aktueller Kurs",
      total_value: "Gesamtwert",
      unrealized_pnl: "Unrealisiertes P&L",
      date: "Datum",
      event: "Ereignis",
      price: "Preis",
      value_eur: "Wert (EUR)",
      actions: "Aktionen",
      ticker: "Ticker",
      name: "Name",
      type: "Typ",
      currency: "Währung",
      last_price: "Letzter Kurs"
    },
    toasts: {
      load_err: "Fehler beim Laden der Daten.",
      asset_deleted: "Asset gelöscht!",
      asset_delete_err: "Asset konnte nicht gelöscht werden.",
      order_deleted: "Order gelöscht!",
      order_delete_err: "Order konnte nicht gelöscht werden.",
      asset_saved: "Asset erfolgreich gespeichert!",
      asset_save_err: "Fehler beim Speichern des Assets.",
      order_saved: "Order erfolgreich erfasst!",
      order_save_err: "Fehler beim Speichern der Order.",
      import_success: "Import erfolgreich abgeschlossen!",
      import_err: "Fehler beim Importieren."
    },
    modal: {
      asset_new_title: "Neues Asset",
      asset_edit_title: "Asset bearbeiten",
      ticker: "Ticker / Kennung",
      ticker_placeholder: "Z.B. SWDA.MI, AAPL, BTC...",
      name: "Asset Name",
      name_placeholder: "Z.B. iShares MSCI World, Apple...",
      isin: "ISIN Code (Optional)",
      isin_placeholder: "Z.B. IE00B4L5Y983...",
      asset_class: "Assetklasse",
      asset_class_placeholder: "Z.B. Aktien, Krypto, Gold...",
      currency: "Notierungswährung",
      currency_placeholder: "EUR, USD usw.",
      current_price: "Aktueller Marktkurs",
      search_ticker: "Ticker suchen (Yahoo Finance)",
      ticker_not_found: "Ticker auf Yahoo Finance nicht gefunden.",
      ticker_verified: "Ticker verifiziert",
      symbol: "Symbol",
      instrument_name: "Instrumentenname",
      original_currency: "Originalwährung",
      save_asset_btn: "Asset im Verzeichnis speichern",
      order_new_title: "Neue Order erfassen",
      order_edit_title: "Order bearbeiten",
      select_asset: "Asset auswählen...",
      select_account: "Gegenkonto Belastung/Gutschrift...",
      order_type_buy: "KAUF",
      order_type_sell: "VERKAUF",
      order_date: "Orderdatum",
      order_shares: "Menge (Anteile)",
      order_price: "Einzelpreis (€)",
      order_commission: "Provision (€, Optional)",
      broker_account: "Broker-Konto",
      event_type: "Ereignistyp",
      buy_option: "KAUF",
      sell_option: "VERKAUF",
      deposit_option: "EINZAHLUNG (Einzahlung Cash)",
      withdraw_option: "AUSZAHLUNG (Auszahlung Cash)",
      dividend_option: "DIVIDENDE",
      interest_option: "ZINSEN (Zinsertrag)",
      fee_option: "GEBÜHR (Provision)",
      unit_price: "Einzelpreis",
      total_value_eur: "Gesamtwert (€)",
      execution_date: "Ausführungsdatum",
      confirm_order_btn: "Order bestätigen",
      registering: "Wird registriert...",
      order_notes: "Notizen / Transaktionsdetails",
      cancel: "Abbrechen",
      save: "Speichern",
      delete_confirm_asset: "Sind Sie sicher, dass Sie dieses Asset löschen möchten? Alle verknüpften Orders werden ebenfalls gelöscht.",
      delete_confirm_order: "Sind Sie sicher, dass Sie diese Order löschen möchten? Der Einstandspreis und die Mengen werden neu berechnet.",
      delete_order_title: "Order löschen",
      delete_order_msg: "Sind Sie sicher, dass Sie diese Order aus dem Register löschen möchten? Diese Operation kann nicht rückgängig gemacht werden und berechnet Positionen und Charts sofort neu."
    },
    import_page: {
      back_btn: "Zurück zum Terminal",
      title: "Broker-Daten importieren",
      subtitle: "Verwalten Sie den Massenimport Ihrer Investitionen.",
      system_aligned: "System abgeglichen",
      ready_data: "Bereit für neue Daten",
      step_staging: "Schritt 1: Staging-Bereich",
      select_broker: "Broker auswählen",
      file_label_csv: "CSV-Datei (Trade Republic)",
      upload_data_btn: "Neue Daten hochladen",
      step_processing: "Schritt 2: Verarbeitung",
      processing_desc: "Analysiert den Staging-Bereich und erfasst die Ereignisse im Register: Käufe, Verkäufe, Dividenden und Gebühren werden auf den Cent genau berechnet.",
      staging_status: "Status Staging-Bereich",
      ready_to_process: "Bereit zur Verarbeitung",
      process_ledger_btn: "Register verarbeiten",
      step_sync: "Schritt 3: Synchronisation",
      sync_desc: "Synchronisiert historische Kurse von Yahoo Finance. Nur fehlende Daten werden geladen, um die Performance zu optimieren.",
      asset_prices: "Asset-Kurse",
      diff_update: "Differenzielles Update",
      smart_backfill_btn: "Smart Backfill",
      footer_info: "Transaktions-ID wird über die eindeutige transaction_id des Brokers erkannt.",
      safe_processing: "Sichere Verarbeitung",
      dup_check: "Duplikatsprüfung aktiv",
      loading_config: "Konfiguration wird geladen...",
      toasts: {
        load_acc_err: "Konten konnten nicht geladen werden.",
        select_file_acc: "Bitte wählen Sie eine Datei und ein Zielkonto aus.",
        uploading_file: "Datei wird in den Staging-Bereich hochgeladen...",
        upload_err: "Fehler beim Upload",
        upload_conn_err: "Verbindungsfehler beim Upload.",
        processing_ledger: "Transaktionen werden verarbeitet und Register aktualisiert...",
        process_err: "Fehler beim Verarbeiten des Registers.",
        process_conn_err: "Verbindungsfehler bei der Verarbeitung.",
        syncing_prices: "Historische Kurse werden von Yahoo Finance synchronisiert...",
        backfill_err: "Fehler beim Laden historischer Kurse.",
        backfill_conn_err: "Verbindungsfehler beim Laden historischer Kurse."
      }
    }
  },
  recurring_page: {
    title: "Abonnements & Wiederkehrende Ausgaben",
    subtitle: "Anzeigen und Verwalten geplanter Ausgaben und wiederkehrender Verträge.",
    new_btn: "Neues Abonnement",
    active_tab: "Aktiv",
    inactive_tab: "Inaktiv",
    forecast_title: "Prognose zukünftiger Ausgaben",
    forecast_loading: "Prognosen werden berechnet...",
    forecast_30d: "Ausgaben in den nächsten 30 Tagen",
    forecast_90d: "Ausgaben in den nächsten 90 Tagen",
    forecast_365d: "Ausgaben in den nächsten 365 Tagen",
    empty_msg: "Keine Abonnements eingerichtet. Fügen Sie Ihr erstes Abonnement hinzu!",
    delete_title: "Abonnement löschen",
    stats_7d: "Nächste 7 Tage",
    stats_eom: "Bis Monatsende",
    stats_30d: "Nächste 30 Tage",
    stats_next_month: "Nächster Monat",
    stats_12m: "Nächste 12 Monate",
    stats_monthly_avg: "Monatlicher Durchschnitt",
    toasts: {
      load_err: "Fehler beim Laden der Daten",
      deleted: "Abonnement gelöscht!",
      delete_err: "Löschen fehlgeschlagen",
      saved: "Abonnement gespeichert!",
      save_err: "Fehler beim Speichern des Abonnements"
    },
    card: {
      frequency_label: "Häufigkeit:",
      next_date_label: "Nächste Fälligkeit:",
      account_label: "Konto:",
      status_label: "Status:",
      active: "Aktiv",
      inactive: "Inaktiv",
      freq_daily: "Täglich",
      freq_weekly: "Wöchentlich",
      freq_monthly: "Monatlich",
      freq_yearly: "Jährlich",
      delete_confirm: "Sind Sie sicher, dass Sie dieses Abonnement löschen möchten?",
      suspend: "Pausieren",
      resume: "Fortsetzen"
    },
    modal: {
      new_title: "Neues Abonnement",
      edit_title: "Abonnement bearbeiten",
      description: "Beschreibung / Name",
      description_placeholder: "Z.B. Netflix, Spotify, Miete...",
      amount: "Betrag (€)",
      category: "Kategorie",
      account: "Belastungskonto",
      frequency: "Häufigkeit",
      next_date: "Nächstes Fälligkeitsdatum",
      is_active: "Aktives Abonnement (erzeugt zukünftige Buchungen)",
      cancel: "Abbrechen",
      save: "Speichern",
      none_placeholder: "Keine..."
    }
  },
  wishlist: {
    delete_btn: "Löschen",
    title: "Wunschliste (Cooling-off Timer)",
    subtitle: "Tragen Sie nicht-essenzielle Wünsche ein, um sie 'abkühlen' zu lassen und Impulskäufe zu vermeiden.",
    add_btn: "Wunsch hinzufügen",
    new_wish: "Neuer Wunsch",
    name: "Name des Artikels",
    name_placeholder: "Z.B. Smartwatch, Neue Schuhe...",
    amount: "Betrag (€)",
    category: "Kategorie",
    merchant: "Händler / Marke",
    merchant_placeholder: "Wählen Sie einen Händler (optional)...",
    product_url: "Produkt-Link",
    product_url_placeholder: "Z.B. https://amazon.de/... (optional)",
    timer: "Bedenkzeit",
    timer_24: "24 Stunden",
    timer_48: "48 Stunden (Empfohlen)",
    timer_72: "72 Stunden",
    notes: "Zusätzliche Notizen",
    notes_placeholder: "Warum möchte ich das kaufen? Brauche ich es wirklich?",
    cancel: "Abbrechen",
    save: "Wunsch speichern",
    total_saved: "Ersparnis durch Selbstkontrolle",
    active_wishes: "Aktive Bedenkzeit",
    archived_wishes: "Entscheidungshistorie",
    time_left: "Verbleibende Zeit:",
    expired: "Zeit abgelaufen!",
    want_it_question: "Möchten Sie es immer noch kaufen?",
    yes_btn: "Ja, ich will es immer noch",
    no_btn: "Nein, ich habe mich umentschieden",
    status_pending: "Bedenkzeit",
    status_saved: "Gespart",
    status_bought: "Gekauft",
    empty_active: "Keine Käufe in der Bedenkzeit. Hervorragende Selbstkontrolle!",
    empty_archive: "Keine Entscheidungen in der Historie erfasst.",
    delete_confirm: "Sind Sie sicher, dass Sie diesen Wunsch löschen möchten?",
    toasts: {
      load_err: "Fehler beim Laden der Wunschliste",
      saved: "Wunsch registriert! Der Abkühltimer hat begonnen.",
      save_err: "Wunsch konnte nicht gespeichert werden",
      deleted: "Wunsch gelöscht",
      delete_err: "Wunsch konnte nicht gelöscht werden",
      decision_saved: "Glückwunsch zur Selbstkontrolle! {amount}€ wurden in Ihren Sparumschlag verschoben.",
      decision_bought: "Wunsch bestätigt. Sie können mit dem Kauf fortfahren!"
    }
  }
};
